const query = (id, isPreview) => `
{
  pressRelease(id: "${id}",preview: ${isPreview}) {
    
    country
    variant
    isYear
    linkOfYearCollection{
      items{
        url
        label
      }
    }
    listOfReleasesCollection (limit : 1000 ) {
      items {
        
        pdf {
          url
          title
        }
        year
        country
        dates
        url{
          url
          title
        }
        pdfLink{
          pdfName
          newLink
          title
          target
        }
      }
    }
  }
}

`
module.exports = { query }
